<template>
	<form class="form normal entry" @submit.prevent="handleSubmit">
		<div class="left-section">
			<div>
				<Logo class="mobile" />

				<Logo :logoOverride="logo2" class="desktop" />

				<div class="testimonial">
					<p class="quote">Data that we could easily translate into actions.</p>

					<div class="name-position">
						<h3 class="name h6 bold">Anna-Roisin Bowles</h3>

						<h4 class="position p">Inter Vivos</h4>
					</div>
				</div>
			</div>
		</div>
		<div class="wrap">
			<div class="wrap-wrap">
				<div class="wrap-wrap-wrap">
					<h2 class="form-section-title low" v-html="title" />

					<p class="start" v-if="!isInvite">Start your journey with a 14-day free trial, during which you can track up to 500 keywords.</p>

					<GoogleSignin 
						@update:showGoogleBtn="showGoogleBtn = $event"
						v-if="!isInvite"
						@success="handleResponse"
						@error="handleError"
					/>

					<div class="or-strip" v-if="showGoogleBtn"><span>Or</span></div>

					<p v-if="showGoogleBtn">Enter your details below...</p>

					<div class="form-section-column">

						<FormInput type="text" :noMarginBottom="true" v-model="firstName" name="firstName" placeholder="Your first name" />

						<FormInput type="text" :noMarginBottom="true" v-model="lastName" name="lastName" placeholder="Your last name" />

						<FormInput
							type="email"
							v-model="email"
							name="email"
							placeholder="Your email address"
							:errors="errors"
							@has-internal-errors="hasInternalErrors"
							:disabled="disableEmail"
							:noMarginBottom="true"
						/>

						<FormInput
							type="password"
							v-model="password"
							name="password"
							placeholder="Your password"
							:errors="errors"
							@has-internal-errors="hasInternalErrors"
							:noMarginBottom="true"
						/>

					</div>

					<p class="agreement">
						By clicking 'Create account'<span v-if="showGoogleBtn"> or 'Sign up with Google'</span>, you agree to our 
						<a href="https://rankcaddy.io/terms-of-use/" target="_blank">terms of use</a> and 
						<a href="https://rankcaddy.io/privacy-policy/" target="_blank">privacy policy.</a>
					</p>

					<p class="error" v-if="typeof errors === 'string' && errors !== ''" v-html="errors" />

					<input type="submit" value="Create account" />

					<p>Already have an account? <router-link to="/login" class="strong primary">Log in</router-link></p>
				</div>
			</div>
		</div>
		<Modal 
			v-if="showHeardAbout"
			:showClose="false"
			:width="500"
		>
			<template v-slot:content>
				<label>How did you hear about us?</label>
				<v-select 
					v-model="heardAbout" 
					:options="heardAboutOptions" 
					:reduce="option => option._id"
					:append-to-body="true"
					placeholder="We'd love to know!"
				/>

				<FormInput
					type="text"
					v-model="heardAboutOther"
					name="heardAboutOther"
					placeholder="Oh cool, where was that?"
					:required="false"
					v-if="heardAbout === 'Other'"
				/>
				<input 
					type="button" 
					class="submit no-margin a-form-button" 
					:value="heardAbout?'Take me to the dashboard':'Just take me to the dashboard'" 
					@click="goToDashboard"
				/>
			</template>
		</Modal>
	</form>
</template>

<script>
	import Vue from "vue";
	import { mapMutations, mapState } from "vuex";
	import ApiService from "./../services/api.service";
	import TrackingService from "./../services/tracking.service";
	import { UserService } from "./../services/user.service";
	import FormInput from "./../components/Form/Input.vue";
	import Logo from "./../components/Logo.vue";
	import Modal from "./../components/Display/Modal.vue";
	import GoogleSignin from "./../components/GoogleSignin.vue";
	import general from "./../utils/general";
	export default {
		name: "CreateAccount",
		components: {
			FormInput,
			Logo,
			Modal,
			GoogleSignin
		},
		data() {
			return {
				gscDone: false,
				showHeardAbout: false,
				firstName: "",
				lastName: "",
				email: "",
				title: "Create an account",
				password: "",
				errors: {},
				token: '',
				heardAbout: '',
				inputErrors: {},
				okToSubmit: true,
				disableEmail: false,
				heardAboutOther: '',
				showGoogleBtn: false,
				heardAboutOptions: [
					{ _id: 'Facebook', label: 'Facebook' },
					{ _id: 'Google', label: 'Google' },
					{ _id: 'YouTube', label: 'YouTube' },
					{ _id: 'Reddit', label: 'Reddit' },
					{ _id: 'LinkedIn', label: 'LinkedIn' },
					{ _id: 'SEO Course/Free Resource', label: 'SEO Course/Free Resource' },
					{ _id: 'Referral (Friend/Colleague/Word of Mouth)', label: 'Referral (Friend/Colleague/Word of Mouth)' },
					{ _id: 'Other', label: 'Other' }
				]
			};
		},
		computed: {
			...mapState("general", ["logo2"]),
			isInvite () {
				return this.$route.params.inviteId && this.$route.params.inviteAuth;
			}
		},
		methods: {
			...mapMutations("general", ["updateLoadingText"]),
			...mapMutations("auth", ["loginSuccess"]),
			getCookie(name) {
				let cookie = {};
				document.cookie.split(";").forEach(function(el) {
					let [k, v] = el.split("=");
					cookie[k.trim()] = v;
				});
				return cookie[name];
			},
			handleSubmit() {
				this.errors = {};

				if (this.okToSubmit) {
					this.updateLoadingText(true);

					const queryString = window.location.search;

					let userData = {
							firstName: this.firstName,
							lastName: this.lastName,
							email: this.email,
							password: this.password,
							meta: {}
						},
						ttclid = this.getCookie("ttclid");
					
					if ( queryString ) {

						const params = new URLSearchParams(queryString);

						params.forEach(function(value, key) {
							userData.meta[key] = value;
						});

					}

					if (!!ttclid) {
						userData.tiktok = {
							ttclid: ttclid,
						};
					}

					if ( this.$route.params.couponCode ) {

						userData.meta.couponCode = this.$route.params.couponCode;

					}

					ApiService.put("users/create", userData)
						.then(
							function(response) {
								this.handleResponse ( response );
							}.bind(this)
						)
						.catch(
							function(error) {
								Vue.set(this, "errors", error.response.data.error);

								this.updateLoadingText();
							}.bind(this)
						);
				}
			},
			handleError ( info ) {
				console.error('handleError',info);
			},
			handleResponse ( response ) {
				console.log('handleResponse',response);
				if (typeof response.data === "object" && typeof response.data.access_token !== "undefined") {
					TrackingService.gtag.event("sign_up_form_complete", {}, "rollup");

					this.token = UserService.processLoginInfo(response);

					if (typeof rdt !== "undefined") {
						rdt("track", "SignUp");
					}

					if (typeof qp !== "undefined") {
						qp("track", "CompleteRegistration");
					}

					if (typeof ttq !== "undefined" && !!response.data.tiktok) {
						ttq.identify({
							email: response.data.tiktok.email,
							external_id: response.data.tiktok.external_id,
						});

						ttq.track("CompleteRegistration", {
							contents: [
								{
									content_id: response.data.tiktok.content_id, // string. ID of the product. Example: "1077218".
									content_type: response.data.tiktok.content_type, // string. Either product or product_group.
									content_name: response.data.tiktok.content_name, // string. The name of the page or product. Example: "shirt".
								},
							],
							value: 0, // number. Value of the order or items sold. Example: 100.
							currency: "USD", // string. The 4217 currency code. Example: "USD".
						});
					}

					this.showHeardAbout = true;

				} else {
					this.errors = response.data;
				}

				this.updateLoadingText();

			},
			hasInternalErrors(a) {
				this.inputErrors[a.name] = a.error;
				this.okToSubmit = true;
				Object.keys(this.inputErrors).forEach(
					function(n) {
						if (this.inputErrors[n].error) {
							this.okToSubmit = false;
						}
					}.bind(this)
				);
			},
			goToDashboard (e) {

				e.preventDefault();

				const queryString = window.location.search;

				let userData = {
						meta: {
							heardAbout: this.heardAbout,
							heardAboutOther: this.heardAboutOther
						}
					},
					ttclid = this.getCookie("ttclid");
				
				if ( queryString ) {

					const params = new URLSearchParams(queryString);

					params.forEach(function(value, key) {
						userData.meta[key] = value;
					});

				}

				if (!!ttclid) {
					userData.tiktok = {
						ttclid: ttclid,
					};
				}

				this.showHeardAbout = false;

				this.updateLoadingText(true);

				this.loginSuccess({ token: this.token });

				ApiService.post("users", userData )
					.then(
						function() {

							window.location.assign('/');

						}.bind(this)
					)
					.catch(
						function(error) {
							this.updateLoadingText();
						}.bind(this)
					);

			}
		},
		mounted() {
			if (typeof fbq !== "undefined") {
				fbq("track", "PageView");
			}

			if (this.$route.params.couponCode) {
				this.updateLoadingText(true);
				ApiService.get(`payment/coupon/check/${this.$route.params.couponCode}`)
					.then(
						function(response) {

							this.updateLoadingText();
							this.errors = response.data.congrats;
							general.$snotify(this,'success','Trial',response.data.congrats)
							
						}.bind(this)
					)
					.catch(
						function(error) {
							this.updateLoadingText();
							general.$snotify(this,'error','Trial',error)
						}.bind(this)
					);
			}

			if (this.isInvite) {
				this.updateLoadingText("One moment...");
				this.isInvite = true;

				ApiService.get("users/invite/email/" + this.$route.params.inviteId + "/" + this.$route.params.inviteAuth)
					.then(
						function(response) {
							this.firstName = response.data.firstName;

							this.lastName = response.data.lastName;

							this.email = response.data.email;

							this.title = response.data.title;

							this.disableEmail = true;

							this.updateLoadingText();
						}.bind(this)
					)
					.catch(
						function(error) {
							this.updateLoadingText();
						}.bind(this)
					);
			}
		}
	}
</script>

<style lang="less" scoped>

	.agreement {

		margin-bottom: 30px;

		a {
			text-decoration: underline;
			
		}
		
	}

</style>